import { render, staticRenderFns } from "./TextLineSettings.vue?vue&type=template&id=564750ec&scoped=true"
import script from "./TextLineSettings.vue?vue&type=script&lang=ts"
export * from "./TextLineSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564750ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('564750ec')) {
      api.createRecord('564750ec', component.options)
    } else {
      api.reload('564750ec', component.options)
    }
    module.hot.accept("./TextLineSettings.vue?vue&type=template&id=564750ec&scoped=true", function () {
      api.rerender('564750ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/label-layout-editor/TextLineSettings.vue"
export default component.exports